export default "__VITE_ASSET__a0fe27a1__"